﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgComponent({
    token: Token.KbMin,
    dependencies: [
    ]
})
export class KbMin extends Directive {
    constructor() {
        super();
        this.restrict = "A";
        this.require = "ngModel";
            
        this.link = (scope, elem, attr, ctrl) => {
            let minValidator = value => {
                let min = scope.$eval(attr.ngMin) || 0;
                if (ctrl.$viewValue && ctrl.$viewValue < min) {
                $(elem).val(min);
                return min;
                }
                return value;
            };

            ctrl.$parsers.push(minValidator);
            ctrl.$formatters.push(minValidator);
        };
    }
}
